<template>
  <div class="courier-vehicles">
    <h5 v-translate>Courier Personal Vehicles</h5>
    <b-table stacked="lg" striped :items="user.vehicles" :fields="vehicleFields" v-if="user.vehicles && user.vehicles.length > 0">

      <template #cell(vehicle_type)="row">
        {{ vehicleTypes.find(x => x.id === row.item.vehicle_type_id)?.name || 'NN'}}
      </template>

      <template #cell(insurance_expiration_date)="row">
        {{row.value ? moment(row.value).format('L') : ''}}
      </template>

      <template #cell(insurance_card_picture)="row">
        <a :href="row.value" target="_blank" v-if="row.value">
          <translate>YES</translate>
        </a>
        <span v-else>
          <translate>NO</translate>
        </span>
      </template>

      <template #cell(vehicle_card_picture)="row">
        <a :href="row.value" target="_blank" v-if="row.value">
          <translate>YES</translate>
        </a>
        <span v-else>
          <translate>NO</translate>
        </span>
      </template>

      <template #cell(active)="row">
        <span v-b-tooltip.html :title="row.item.active ? $gettext('Enabled') : $gettext('Disabled')" style="display: inline-block; width:10px; height:10px; border-radius: 100px;" :class="row.item.active ? 'bg-success' : 'bg-danger'"></span>
      </template>

      <template #cell(actions)="row">
        <div class="text-nowrap">
          <b-button size="sm" variant="danger" @click.stop="deleteVehicle(row.item)">
            <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
          </b-button>
          <b-button size="sm" @click.stop="editVehicle(row.item)">
            <font-awesome-icon :icon="['fa', 'pencil-alt']" size="2x" style="font-size: 16px;vertical-align: middle" />
          </b-button>
        </div>
      </template>

    </b-table>
    <b-button @click.prevent="$refs.modalAddVehicle.show()" v-translate>Add Vehicle</b-button>

    <b-modal ref="modalAddVehicle" hide-footer>
      <template #modal-title>
        <translate>Add new vehicle to user</translate>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <api-item-edit type="userVehicles" :model="vehiclesModel" @success="$refs.modalAddVehicle.hide(); $emit('updated');" />
    </b-modal>

    <b-modal ref="modalEditVehicle" hide-footer @hidden="editingVehicle = null">
      <template #modal-title>
        <translate>Edit vehicle</translate>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <api-item-edit type="userVehicles" :id="editingVehicle?.id" :model="vehiclesModel" @success="$refs.modalEditVehicle.hide(); $emit('updated');" />
    </b-modal>
  </div>
</template>

<script>
import { UserService } from '@/services/api'
import ApiItemEdit from '@/components/ApiLists/ApiItemEdit'

export default {
  name: 'CourierVehicles',
  components: {
    ApiItemEdit
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editingVehicle: null,
      vehicleFields: [
        {
          key: 'reference',
          label: this.$gettext('Reference')
        },
        {
          key: 'plate_number',
          label: this.$gettext('Plate Number')
        },
        {
          key: 'vehicle_type',
          label: this.$gettext('Type')
        },
        {
          key: 'insurance_expiration_date',
          label: this.$gettext('Insurance Exp.')
        },
        {
          key: 'vehicle_card_picture',
          label: this.$gettext('Vehicle Card')
        },
        {
          key: 'insurance_card_picture',
          label: this.$gettext('Insurance Card')
        },
        {
          key: 'active',
          label: this.$gettext('Enabled')
        },
        {
          key: 'actions',
          label: this.$gettext('Actions')
        }
      ]
    }
  },
  computed: {
    vehiclesModel() {
      return { ...this.models.userVehicles, endpoint: this.models.userVehicles.endpoint.replace('{id}', this.user.id) }
    }
  },
  methods: {
    editVehicle(vehicle) {
      this.editingVehicle = vehicle
      this.$refs.modalEditVehicle.show()
    },
    deleteVehicle(vehicle) {
      if (confirm(this.$gettext('Are you sure you want to DELETE this vehicle?'))) {
        UserService.deleteVehicle(this.user.id, vehicle.id)
          .then(() => {
            this.$emit('updated')
          })
      }
    }
  }
}
</script>
